import {twMerge} from "tailwind-merge";

export default function SimpleSearchInput({id, classes = {}, ...otherProps}) {

    const {inputClasses = "", parentClasses = "", buttonClasses = ""} = classes;
    return (
        <label className={twMerge("relative", parentClasses)}>
            <input
                id={id}
                type="search"
                className={twMerge("w-full border border-pol-gray-light-3 hover:border-pol-blue rounded-2xl text-pol-dark placeholder:text-pol-gray-100 placeholder:font-semibold pr-4 pl-8 py-3.5 outline-none duration-300", inputClasses)}
                {...otherProps}/>
            <button className={twMerge("absolute left-3.5 top-0.5", buttonClasses)}><i className="icon-search" /></button>
        </label>
    )
}
